/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MerchantOverviewList } from '../../models/merchant-overview-list';

export interface ApiTicketItemIdMerchantsGet$Params {
  item_id: number;
}

export function apiTicketItemIdMerchantsGet(http: HttpClient, rootUrl: string, params: ApiTicketItemIdMerchantsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<MerchantOverviewList>> {
  const rb = new RequestBuilder(rootUrl, apiTicketItemIdMerchantsGet.PATH, 'get');
  if (params) {
    rb.path('item_id', params.item_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MerchantOverviewList>;
    })
  );
}

apiTicketItemIdMerchantsGet.PATH = '/api/ticket/{item_id}/merchants';
